import React, { useState, useEffect } from "react";
import api from "../../services/api";
import PrintingSheetsPanel from "./PrintingSheetsPanel";

export default function PrintingPage() {

  const [activeSheetsTab, setActiveSheetsTab] = useState("current"); // current | completed

  return (
    <div className="container-fluid py-4">
        <div className="d-flex justify-content-between">
        <h3 className="mb-3">Листы на печать</h3>
        </div>

        <PrintingSheetsPanel
        activeTab={activeSheetsTab}
        setActiveTab={setActiveSheetsTab}
        />
    </div>
  );
}
